module.exports = __webpack_public_path__ + "static/media/downArrow.da78dd17.png";